// extracted by mini-css-extract-plugin
module.exports = {"select":"budget-controls_select__vhNDx"};